<template>
  <main class="content">
      <div class="row">
          <h1>
              Edit screensaver
          </h1>
      </div>
      <form class="form">
          <Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>
          <fieldset class="form--item">
              <label class="label" for="">
                  Youtube or Vimeo Link:
              </label>
              <div class="input_text">
                  <input name="" placeholder="Paste a URL link from a Youtube or Vimeo video" type="text" required v-model="screensaver.videoDetails.link"/>
              </div>
          </fieldset>
          <div class="row">
              <a class="btn btn_green u-fleft u-mr1" @click="updateBlocked()">
                  Update
              </a>
              <a class="btn btn_red u-fleft" @click="confirmToggle()">
                  Delete
              </a>
          </div>
      </form>
      <confirm resource="screensaver" :visible.sync="alertVisible"></confirm>
      <ok resource="screensaver" resource-plural="screensavers" :visible.sync="okVisible"></ok>
      <loading :visible.sync="loadingVisible"></loading>
  </main>
</template>
<script>
import * as EditResource from '../../mixins/editResource.mixin';
import * as ValidateForm from '../../mixins/validate-form.mixin';

import Confirm from '../Modals/modal_confirm';
import Ok from '../Modals/modal_ok';
import Loading from '../Loading.vue'
import Message from '../Message.vue'

export default {
  name: 'EditScreenSavers',
  components: { Confirm, Ok, Message,Loading },
  mixins: [ValidateForm, EditResource],
  data () {
    return {
      model: 'screensaver',
      resource: 'screensavers',
      parentResource: 'ScreenSavers',
      alertVisible: false,
      okVisible: false,
      screensaver: {
        videoDetails: {}
      }
    }
  },
  mounted(){
    var self = this;
    this.fetchResource(this.$route.params.id, {});
  },
  methods: {
    updateBlocked(){
      this.screensaver = {
        link: this.screensaver.videoDetails.link
      }
      this.updateResource(this.$route.params.id, this.screensaver);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EditScreenSavers.vue?1b41ffe3